var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"indeterminate":"","height":"2"}}),_c('div',{ref:"map",staticClass:"ametras-map"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }